import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselBannerV3Component } from './carousel-banner-v3/carousel-banner-v3.component';
import { ExtendedModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { RouterLinkWithHref } from '@angular/router';
import { SharedModule } from '../@shared/shared.module';
import { SwiperModule } from 'swiper/angular';
import { UtilitiesModule } from '../utilities/utilities.module';
import { TwoColBannerWithTitleV2Component } from './two-col-banner-with-title-v2/two-col-banner-with-title-v2.component';
import { CollectionBannerV3Component } from './collection-banner-v3/collection-banner-v3.component';
import { SliderWithSubtextV4Component } from './slider-with-subtext-v4/slider-with-subtext-v4.component';
import { CategoryTabSectionV2Component } from './category-tab-section-v2/category-tab-section-v2.component';
import { OneColBannerV2Component } from './one-col-banner-v2/one-col-banner-v2.component';
import { OfferStripCarouselComponent } from './offer-strip-carousel/offer-strip-carousel.component';

@NgModule({
    declarations: [
        CarouselBannerV3Component,
        TwoColBannerWithTitleV2Component,
        CollectionBannerV3Component,
        SliderWithSubtextV4Component,
        CategoryTabSectionV2Component,
        OneColBannerV2Component,
        OfferStripCarouselComponent,
    ],
    imports: [
        CommonModule,
        ExtendedModule,
        MatButtonModule,
        RouterLinkWithHref,
        SharedModule,
        SwiperModule,
        UtilitiesModule,
    ],
    exports: [
        CarouselBannerV3Component,
        TwoColBannerWithTitleV2Component,
        CollectionBannerV3Component,
        SliderWithSubtextV4Component,
        CategoryTabSectionV2Component,
        OneColBannerV2Component,
        OfferStripCarouselComponent,
    ],
})
export class SharedLayoutsModule {}
